import { render, staticRenderFns } from "./CreatModal.vue?vue&type=template&id=8bc91194&scoped=true"
import script from "./CreatModal.vue?vue&type=script&lang=js"
export * from "./CreatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc91194",
  null
  
)

export default component.exports